<template>
  <div class="modal-container clearfix">
    <div class="add-box clearfix">
      <table-header @add="insertEvent" @remove="removeEvent" @copy="paste"></table-header>
      <vxe-table
          border
          show-overflow
          ref="xTable"
          class="table-style"
          max-height="450"
          :auto-resize="true"
          align="center"
          :data="tableData"
          :edit-rules="tableRules"
          :edit-config="{trigger: 'click', mode: 'cell'}"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
          @scroll="clearTableV"
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column field="no" title="序号" width="60"></vxe-table-column>
        <vxe-table-column field="realName" title="姓名">
          <template v-slot:header>
            <span style="color: red">*</span>姓名
          </template>
          <template v-slot="scope">
            <vxe-input v-model="scope.row.realName" placeholder="必填" @blur="clearTableV"
                       @input="(file)=>checkUserName(file,scope.row)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="regisiterNum" title="注册手机号">
          <template v-slot:header>
            <span style="color: red">*</span>注册手机号
          </template>
          <template v-slot="scope">
            <vxe-input v-model="scope.row.regisiterNum" placeholder="必填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column title="身份类型" width="120" field="userCategoryStr">
          <template v-slot:header>
            <span style="color: red">*</span>身份类型
          </template>
          <template v-slot="{ row }">
            <vxe-select
                v-model="row.userCategoryStr"
                placeholder="请选择"
                :options="userCategoryType"
                transfer
            ></vxe-select>
          </template>
        </vxe-table-column>
        <vxe-table-column field="idcardNum" title="身份证号码">
          <!--          <template v-slot:header>-->
          <!--            <span style="color: red">*</span>身份证号码-->
          <!--          </template>-->
          <template v-slot="scope">
            <vxe-input v-model="scope.row.idcardNum" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
        <vxe-table-column field="phoneNum" title="联系方式">
          <template v-slot="scope">
            <vxe-input v-model="scope.row.phoneNum" placeholder="选填"
                       @input="$refs.xTable.updateStatus(scope)"></vxe-input>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="modal-footer add-btn-box">
      <Button type="primary" @click="impotEvent">上传导入文件</Button>
      <Button type="primary" @click="commit">保 存</Button>
    </div>
    <vxe-modal v-model="messageVisible" title="消息提示" width="600" height="350" @close="closeMessage" remember>
      <Message ref="messageModal" @close="closeMessage"></Message>
    </vxe-modal>
  </div>
</template>

<script>
import $api from '@/apiProvider';
import XLSX from "xlsx";
import Message from "@/components/common/Message";
import {getExcelTime, showLoading, hideLoading, isEmpty} from '@/utils/util';
import TableHeader from "../../components/common/TableHeader";
import md5 from "js-md5";

export default {
  components: {Message, TableHeader},
  data() {
    return {
      userCategoryType: [{
        label: '货主',
        value: '货主'
      },
        {
          label: '船东',
          value: '船东'
        },
        {
          label: '司机',
          value: '司机'
        },
        {
          label: '代理',
          value: '代理'
        },
        {
          label: '船员',
          value: '船员'
        },
        {
          label: '供应商',
          value: '供应商'
        },
        {
          label: '其他',
          value: '其他'
        }
      ],
      userCategoryData: {
        options: []
      },
      tableData: [{
        no: 1,
        userCategoryStr: null,
        userName: null,
        realName: null,
        idcardNum: null,
        phoneNum: null,
        regisiterNum: null,
        password: md5("888999"),
        userType: 1,
      }],
      tableRules: {
        userName: [
          {required: true, message: "请输入客户名称"},
          {max: 20, message: '客户名称不能超过20个字符'}
        ],
        userCategoryStr: [
          {required: true, message: "请选择身份类型"}
        ],
        realName: [
          {required: true, message: "请输入姓名"},
          {max: 20, message: '姓名不能超过20个字符'}
        ],
        idcardNum: [
          // {required: true, message: "请输入身份证号"},
          {min: 18, max: 18, message: '请输入正确的身份证号码'},
          {validator: this.requireValid}
        ],
        phoneNum: [
          {min: 11, max: 11, message: '请输入正确的联系方式'},
          {validator: this.requireValid}
        ],
        regisiterNum: [
          {required: true, message: "请输入手机号"},
          {min: 11, max: 11, message: '请输入正确的手机号'},
          {validator: this.requireValid}
        ],
      },
      messageVisible: false,
      message: '',
      records: [],
      userCategoryMap: new Map(),
    }
  },
  mounted() {
    this.getDicUserCategoryList();
  },
  methods: {
    checkUserName(e, row) {
      row.realName = e.replace('(', '（').replace(')', '）');
    },
    requireValid(e) {
      if (e.column.title === '注册手机号' && !isEmpty(e.row.regisiterNum)) {
        let regPhone = new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/);
        let validPhone = regPhone.test(e.row.regisiterNum);
        if (!validPhone) {
          return Promise.reject(new Error("请输入正确的手机号"));
        }
      }
      if (e.column.title === '身份证号码' && !isEmpty(e.row.idcardNum)) {
        let _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        let _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
        let validIDre = _IDRe18.test(e.row.idcardNum) || _IDre15.test(e.row.idcardNum);
        if (!validIDre) {
          return Promise.reject(new Error("请输入正确的身份证号码"));
        }
      }
      if (e.column.title === '联系方式' && !isEmpty(e.row.phoneNum)) {
        let regPhone = new RegExp(/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/);
        let validPhone = regPhone.test(e.row.phoneNum);
        if (!validPhone) {
          return Promise.reject(new Error("请输入正确的手机号"));
        }
      }
    },
    getDicUserCategoryList() {
      var self = this
      self.userCategoryData = {options: []}
      self.userCategoryMap = new Map();
      $api.other.getDicUserCategoryModel
          .GET({
            params: {
              page: 1,
              rows: 100,
            },
          })
          .then((res) => {
            res.data.forEach((item) => {
              var obj = {
                label: item.dictText,
                value: item.dictCode
              }
              self.userCategoryData.options.push(obj);
              self.userCategoryMap.set(item.dictText, item.dictCode);
            });
          });
    },
    selectChangeEvent({checked, row}) {
      if (checked) {
        this.records.push(row);
      } else {
        let key = this.records.indexOf(row);
        this.records.splice(key, 1);
      }
    },
    selectAllEvent({checked, records}) {
      if (checked) {
        this.records = records;
      } else {
        this.records = [];
      }
    },
    closeMessage() {
      this.messageVisible = false;
    },
    impotEvent() {
      var self = this;
      this.$refs.xTable.readFile({
        types: ['xls', 'xlsx']
      }).then(evnt => {
        showLoading();
        const tableData = [];
        const files = evnt.target.files;
        const fileReader = new FileReader();
        fileReader.onload = async (ev) => {
          const data = ev.target.result;
          const workbook = XLSX.read(data, {type: 'binary'});
          const csvData = XLSX.utils.sheet_to_csv(Object.values(workbook.Sheets)[0]);
          // 解析数据
          let xlsxData = csvData.split('\n');
          let phoneArr = [];
          //删除xlsx列名
          xlsxData.splice(0, 1);
          xlsxData.forEach((vRow) => {
            if (vRow) {
              const vCols = vRow.split(',');
              const item = {
                no: vCols[0],
                realName: vCols[1].replace(/\s*/g, "").replace('(', '（').replace(')', '）'),
                regisiterNum: vCols[2],
                userCategoryStr: vCols[3],
                idcardNum: vCols[4],
                phoneNum: vCols[5],
                password: md5("888999"),
                userType: 1,
              };

              if (vCols[2]) {
                phoneArr.push(vCols[2]);
              }

              tableData.push(item);
            }
          })

          let res = await $api.gcdUser.request("queryUserInfoClientDetailList", {loginNames: phoneArr});
          if(res.status === 1){
            tableData.map(i=>{
              res.data.map(j=>{
                if(i.regisiterNum === j.loginName){
                  if(!i.realName || i.realName === ''){
                    i.realName = j.realName;
                  }
                  if(!i.userCategoryStr  || i.userCategoryStr === ''){
                    i.userCategoryStr = j.tagsStr;
                  }
                  if(!i.idcardNum || i.idcardNum === ''){
                    i.idcardNum = j.idcardNum;
                  }
                }
              })
            })
          }

          this.tableData = tableData;
        }
        fileReader.readAsBinaryString(files[0]);
        setTimeout(() => {
          hideLoading();
        }, 1000);
      })
    },
    async insertEvent() {
      let record = {
        no: this.$refs.xTable.data.length + 1,
        userName: null,
        userCategoryStr: null,
        realName: null,
        idcardNum: null,
        phoneNum: null,
        password: md5("888999"),
        regisiterNum: null,
        userType: 1,
      };
      this.pushIntoTable(record);
    },
    paste() {
      let records = this.records.sort((a, b) => a.no - b.no);
      if (records.length > 0) {
        records.map(i => {
          let record = Object.assign({}, i)
          record.no = this.$refs.xTable.data.length + 1;
          this.pushIntoTable(record);
        })
      } else {
        this.$XModal.message({status: "error", message: "请选择需要复制的信息！"});
      }
    },
    pushIntoTable(record) {
      let {row: newRow} = this.$refs.xTable.insertAt(record, -1);
      this.$refs.xTable.data.push(record);
      this.$refs.xTable.setActiveCell(newRow, "userName");
    },
    async validEvent() {
      let errMap = await this.$refs.xTable
          .validate()
          .catch((errMap) => errMap);
      return errMap ? false : true
    },
    removeEvent() {
      let records = this.records;
      if (records.length > 0) {
        if (this.$refs.xTable.tableData.length > 1) {
          this.$XModal.confirm("您确定要删除选中数据?").then((type) => {
            if (type === "confirm") {
              this.clearTableV()
              records.map(i => {
                this.$refs.xTable.remove(i);
                let key = this.$refs.xTable.data.indexOf(i);
                this.$refs.xTable.data.splice(key, 1);
              })
              this.records = [];
              if (this.isExport === false) {
                this.$refs.xTable.data.map((j, index) => {
                  j.no = index + 1;
                })
              }
            }
          });
        } else {
          this.$XModal.alert({
            message: "已经是最后一条了！",
            status: "warning",
          });
        }
      } else {
        this.$XModal.message({status: "error", message: "请选择需要删除的信息！"});
      }
    },
    clearTableV() {
      this.$refs.xTable.clearValidate();
    },
    async commit() {
      let sts = await this.validEvent()
      if (!sts) {
        this.$XModal.message({status: "error", message: "校验不通过！"});
        return
      }
      this.save();
    },
    async save() {
      showLoading();
      let arr = JSON.parse(JSON.stringify(this.tableData));
      hideLoading()
      arr.map(i => {
        if (i.realName) {
          i.realName = i.realName.trim();
          i.userName = i.realName.trim();
        }
      })
      let res = await $api.baseUserSign.request('batchCreateAndSaveBaseUserSignTwo', arr);
      if (res.status === 1) {
        this.$Message.success('提交成功');
        this.close();
        this.$emit('afterSave');
        // this.batchWYMIdlephoneCheck(res.data.userList);
      } else {

        if (res.data) {
          let data = res.data.errorList;
          let message = '';
          if (data.length > 0) {
            data.map(i => {
              message = message + '序号' + (this.tableData[i.failArrayIndex].no) + '，' + i.failMsg + '\n';
            })
            // let errorData = []
            // data.forEach(failItem => {
            //   errorData.push(Object.assign({}, this.tableData[failItem.failArrayIndex]));
            // })
            // this.tableData = errorData;
          }
          if (message === '') {
            this.$XModal.alert({
              message: "接口异常",
              status: "error",
            });
          } else {
            this.$refs.messageModal.setMessage(message);
            this.messageVisible = true;
          }
        } else {
          this.$XModal.alert({
            message: res.message,
            status: "error",
          });
        }

      }
    },
    async batchWYMIdlephoneCheck(list) {
      showLoading()
      let res = await $api.gcdUser.post("batchAliMIdlephoneCheck", list);
      hideLoading();
      if (res.status === 1) {
        this.$Message.success('提交成功');
        this.close();
        this.$emit('afterSave');
      } else {
        this.$XModal.alert({
            message: "本次导入操作部分手机号出错，请前往导入记录查看！",
            status: "question",
          });
          this.close();
        // let data = res.data;
        // let message = '';
        // if (data.length > 0) {
        //   data.map(i => {
        //     message = message + i.failMsg + '，' + '\n';
        //   })
        // }
        // if (message === '') {
        //   this.$XModal.alert({
        //     message: "接口异常",
        //     status: "error",
        //   });
        // } else {
        //   this.$Message.success('提交成功');
        //   this.close();
        //   this.$emit('afterSave', message);
        // }
      }
    },
    close() {
      this.tableData = [{
        no: 1,
        userName: null,
        realName: null,
        idcardNum: null,
        phoneNum: null,
        regisiterNum: null,
        password: md5("888999"),
        userType: 1,
      }];
    }
  }
}
</script>

<style>

</style>